// check the token query param value is in the right format
export const validateToken = (token: string): string[] | undefined => {
  if (token && token.length === 11 && /^([0-9]{3}-[0-9]{3}-[0-9]{3})$/.test(token)) {
    return token.split('-');
  }
  return;
};
